//#region src/errors/error-with-violations.ts
var e = class extends Error {
	errors;
	constructor(e) {
		super(e.detail), this.errors = e, this.violationsTitleToMessage();
	}
	violationsTitleToMessage() {
		this.errors.violations?.forEach((e) => {
			"title" in e && (e.message = e.title, delete e.title);
		});
	}
	getJoinedViolationMessages() {
		return this.errors.violations?.map((e) => e.message).join(", ");
	}
};
//#endregion
export { e as ErrorWithViolations };
